/* ============================================================
   ProtoClinical: pdp.js
   Product-page behaviour on top of the shared engine (app.js +
   signature.js). Adds: gallery, INSTANT variant switching
   (price · availability · media crossfade · ?variant= URL),
   quantity, AJAX add-to-cart, sticky ATC bar, accordions,
   review bars. Every buy action works with motion off.
   ============================================================ */
(function () {
  "use strict";
  var CFG = window.PC_CONFIG || {};
  const REDUCED = (typeof window.PC_REDUCED === "boolean") ? window.PC_REDUCED
    : window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---- minimal Shopify money formatter ---- */
  function formatMoney(cents, format) {
    format = format || CFG.moneyFormat || "${{amount}}";
    function n(number, decimals, thousands, decimal) {
      number = (number / 100).toFixed(decimals);
      var parts = number.split(".");
      var dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + (thousands || ","));
      var cts = parts[1] ? (decimal || ".") + parts[1] : "";
      return dollars + cts;
    }
    return format.replace(/\{\{\s*(\w+)\s*\}\}/g, function (m, key) {
      switch (key) {
        case "amount": return n(cents, 2, ",", ".");
        case "amount_no_decimals": return n(cents, 0, ",", ".");
        case "amount_with_comma_separator": return n(cents, 2, ".", ",");
        case "amount_no_decimals_with_comma_separator": return n(cents, 0, ".", ",");
        case "amount_with_space_separator": return n(cents, 2, " ", ",");
        default: return n(cents, 2, ",", ".");
      }
    });
  }

  /* =======================================================
     STATE
  ======================================================= */
  const section = $("[data-product-section]");
  let VARIANTS = [];
  try { VARIANTS = JSON.parse($("[data-pdp-variants]").textContent); } catch (e) { VARIANTS = []; }
  const STATE = { variant: VARIANTS[0] || null, qty: 1, galleryIdx: 0 };

  /* =======================================================
     GALLERY
  ======================================================= */
  const ARC_ANGLES = [225, 210, 195, 180, 165, 150, 135];

  function positionThumbnails(activeIndex) {
    const viewport = $("[data-orbit-viewport]");
    const ellipse = $("[data-orbit-ellipse]");
    const thumbnails = $$("#galleryThumbs .gthumb");
    const remaining = $("[data-gallery-remaining]");
    if (!viewport || !ellipse || !thumbnails.length) return;

    if (!window.matchMedia("(min-width: 961px)").matches) {
      thumbnails.forEach((thumbnail) => {
        thumbnail.removeAttribute("data-orbit-visible");
        thumbnail.removeAttribute("data-orbit-slot");
        thumbnail.removeAttribute("data-orbit-angle");
        thumbnail.removeAttribute("aria-hidden");
        thumbnail.style.removeProperty("left");
        thumbnail.style.removeProperty("top");
      });
      if (remaining) remaining.textContent = "";
      return;
    }

    const viewportRect = viewport.getBoundingClientRect();
    const ellipseRect = ellipse.getBoundingClientRect();
    const centerX = ellipseRect.left - viewportRect.left + (ellipseRect.width / 2);
    const centerY = ellipseRect.top - viewportRect.top + (ellipseRect.height / 2);
    const ellipseRadiusX = ellipseRect.width / 2;
    const ellipseRadiusY = ellipseRect.height / 2;
    const thumbnailHalf = (thumbnails[0].offsetWidth || 72) / 2;
    const safeInset = thumbnailHalf + 10;
    const radiusX = Math.max(0, Math.min(ellipseRadiusX * .85, centerX - safeInset));
    const verticalLimit = Math.min(centerY - safeInset, viewportRect.height - centerY - safeInset) / Math.sin(Math.PI / 4);
    const radiusY = Math.max(0, Math.min(ellipseRadiusY * .82, verticalLimit));
    const maxStart = Math.max(0, thumbnails.length - ARC_ANGLES.length);
    const windowStart = Math.max(0, Math.min(maxStart, activeIndex - Math.floor(ARC_ANGLES.length / 2)));

    thumbnails.forEach((thumbnail, mediaIndex) => {
      const slotIndex = mediaIndex - windowStart;
      const angle = ARC_ANGLES[slotIndex];
      if (angle === undefined) {
        thumbnail.removeAttribute("data-orbit-visible");
        thumbnail.removeAttribute("data-orbit-slot");
        thumbnail.removeAttribute("data-orbit-angle");
        thumbnail.setAttribute("aria-hidden", "true");
        return;
      }

      const radians = angle * Math.PI / 180;
      const x = centerX + radiusX * Math.cos(radians);
      const y = centerY + radiusY * Math.sin(radians);
      thumbnail.style.left = x.toFixed(2) + "px";
      thumbnail.style.top = y.toFixed(2) + "px";
      thumbnail.setAttribute("data-orbit-visible", "");
      thumbnail.setAttribute("data-orbit-slot", String(slotIndex));
      thumbnail.setAttribute("data-orbit-angle", String(angle));
      thumbnail.removeAttribute("aria-hidden");
    });

    viewport.dataset.orbitCenterX = centerX.toFixed(2);
    viewport.dataset.orbitCenterY = centerY.toFixed(2);
    viewport.dataset.orbitRadiusX = radiusX.toFixed(2);
    viewport.dataset.orbitRadiusY = radiusY.toFixed(2);
    viewport.dataset.orbitEllipseRadiusX = ellipseRadiusX.toFixed(2);
    viewport.dataset.orbitEllipseRadiusY = ellipseRadiusY.toFixed(2);
    viewport.dataset.orbitWindowStart = String(windowStart);
    const hiddenOutsideSlots = Math.max(0, thumbnails.length - ARC_ANGLES.length);
    if (remaining) remaining.textContent = hiddenOutsideSlots > 0 ? "+" + hiddenOutsideSlots : "";
  }

  function keepThumbVisible(thumb, rail) {
    if (!thumb || !rail || !window.matchMedia("(max-width: 960px)").matches) return;
    const horizontal = rail.scrollWidth > rail.clientWidth;
    if (horizontal) {
      const left = thumb.offsetLeft;
      const right = left + thumb.offsetWidth;
      if (left < rail.scrollLeft) rail.scrollTo({ left: left, behavior: REDUCED ? "auto" : "smooth" });
      else if (right > rail.scrollLeft + rail.clientWidth) rail.scrollTo({ left: right - rail.clientWidth, behavior: REDUCED ? "auto" : "smooth" });
    }
  }

  function switchGallery(idx) {
    const slides = $$("#galleryMain .gslide");
    const thumbs = $$("#galleryThumbs .gthumb");
    if (!slides.length) return;
    idx = Math.max(0, Math.min(slides.length - 1, idx));
    slides.forEach((s, i) => {
      const on = i === idx;
      s.toggleAttribute("data-active", on);
      s.setAttribute("aria-hidden", on ? "false" : "true");
      if (!on) $$('video, audio', s).forEach((media) => media.pause());
    });
    thumbs.forEach((t, i) => {
      const on = i === idx;
      t.toggleAttribute("data-active", on);
      t.setAttribute("aria-selected", on ? "true" : "false");
      t.setAttribute("tabindex", on ? "0" : "-1");
      if (on) t.setAttribute("aria-current", "true"); else t.removeAttribute("aria-current");
    });
    $$("#galleryDots button").forEach((d, i) => d.toggleAttribute("data-active", i === idx));

    const current = $("[data-gallery-current]");
    const progress = $("[data-gallery-progress]");
    if (current) current.textContent = String(idx + 1);
    if (progress) {
      progress.setAttribute("aria-valuenow", String(idx + 1));
      progress.style.setProperty("--gallery-progress", String((idx + 1) / slides.length));
    }
    keepThumbVisible(thumbs[idx], $("#galleryThumbs"));
    positionThumbnails(idx);
    STATE.galleryIdx = idx;
  }
  function galleryIndexForMediaId(id) {
    const slides = $$("#galleryMain .gslide");
    for (let i = 0; i < slides.length; i++) { if (String(slides[i].dataset.mediaId) === String(id)) return i; }
    return -1;
  }
  function initGallery() {
    const main = $(".gallery-main");
    const viewport = $("#galleryMain");
    if (!main || !viewport) return;
    const slides = $$(".gslide", viewport);
    const thumbRail = $("#galleryThumbs");
    const orbitViewport = $("[data-orbit-viewport]");
    const thumbs = thumbRail ? $$(".gthumb", thumbRail) : [];
    setTimeout(() => main.classList.add("loaded"), REDUCED ? 0 : 380);

    thumbs.forEach((t, i) => {
      t.addEventListener("click", () => {
        if (thumbRail && thumbRail.dataset.dragged === "true") return;
        switchGallery(i);
      });
      t.addEventListener("mouseenter", () => {
        if (thumbRail && !thumbRail.classList.contains("is-dragging") && window.matchMedia("(hover:hover)").matches) switchGallery(i);
      });
      t.addEventListener("keydown", (e) => {
        let next = null;
        if (e.key === "ArrowRight" || e.key === "ArrowDown") next = (i + 1) % thumbs.length;
        if (e.key === "ArrowLeft" || e.key === "ArrowUp") next = (i - 1 + thumbs.length) % thumbs.length;
        if (e.key === "Home") next = 0;
        if (e.key === "End") next = thumbs.length - 1;
        if (next === null) return;
        e.preventDefault();
        switchGallery(next);
        thumbs[next].focus({ preventScroll: true });
      });
    });
    const dotWrap = $("#galleryDots");
    if (dotWrap && slides.length > 1 && slides.length <= 8) {
      dotWrap.innerHTML = slides.map((_, i) => `<button type="button" aria-label="Image ${i + 1}"${i === 0 ? " data-active" : ""}></button>`).join("");
      $$("button", dotWrap).forEach((d, i) => d.addEventListener("click", () => switchGallery(i)));
    }
    $("#galleryPrev") && $("#galleryPrev").addEventListener("click", () => switchGallery((STATE.galleryIdx || 0) - 1));
    $("#galleryNext") && $("#galleryNext").addEventListener("click", () => switchGallery((STATE.galleryIdx || 0) + 1));

    let sx = 0, sw = false;
    viewport.addEventListener("touchstart", (e) => { sx = e.touches[0].clientX; sw = true; }, { passive: true });
    viewport.addEventListener("touchend", (e) => {
      if (!sw) return; sw = false;
      const dx = e.changedTouches[0].clientX - sx;
      if (Math.abs(dx) > 40) switchGallery((STATE.galleryIdx || 0) + (dx < 0 ? 1 : -1));
    });

    const more = $("[data-gallery-more]");
    if (more) more.addEventListener("click", () => switchGallery(((STATE.galleryIdx || 0) + 1) % slides.length));

    if (orbitViewport) {
      let wheelLocked = false;
      orbitViewport.addEventListener("wheel", (e) => {
        if (!window.matchMedia("(min-width: 961px)").matches || Math.abs(e.deltaY) < 8) return;
        if (wheelLocked) return;
        const target = Math.max(0, Math.min(slides.length - 1, (STATE.galleryIdx || 0) + (e.deltaY > 0 ? 1 : -1)));
        if (target === STATE.galleryIdx) return;
        e.preventDefault();
        wheelLocked = true;
        switchGallery(target);
        window.setTimeout(() => { wheelLocked = false; }, REDUCED ? 0 : 240);
      }, { passive: false });
    }

    if (thumbRail) {
      let orbitFrame = 0;
      const queueOrbitUpdate = () => {
        if (orbitFrame) window.cancelAnimationFrame(orbitFrame);
        orbitFrame = window.requestAnimationFrame(() => { orbitFrame = 0; positionThumbnails(STATE.galleryIdx || 0); });
      };
      window.addEventListener("resize", queueOrbitUpdate, { passive: true });

      let pointerId = null, startX = 0, startY = 0, startLeft = 0, startTop = 0, moved = false;
      thumbRail.addEventListener("pointerdown", (e) => {
        if (!window.matchMedia("(max-width: 960px)").matches || e.pointerType === "touch" || e.button !== 0) return;
        pointerId = e.pointerId; startX = e.clientX; startY = e.clientY;
        startLeft = thumbRail.scrollLeft; startTop = thumbRail.scrollTop; moved = false;
        thumbRail.dataset.dragged = "false";
        thumbRail.classList.add("is-dragging");
        thumbRail.setPointerCapture(pointerId);
      });
      thumbRail.addEventListener("pointermove", (e) => {
        if (pointerId !== e.pointerId) return;
        const dx = e.clientX - startX, dy = e.clientY - startY;
        if (Math.abs(dx) + Math.abs(dy) > 5) moved = true;
        thumbRail.scrollLeft = startLeft - dx;
        thumbRail.scrollTop = startTop - dy;
      });
      const endDrag = (e) => {
        if (pointerId !== e.pointerId) return;
        if (thumbRail.hasPointerCapture(pointerId)) thumbRail.releasePointerCapture(pointerId);
        pointerId = null;
        thumbRail.classList.remove("is-dragging");
        thumbRail.dataset.dragged = moved ? "true" : "false";
        window.setTimeout(() => { thumbRail.dataset.dragged = "false"; }, 0);
      };
      thumbRail.addEventListener("pointerup", endDrag);
      thumbRail.addEventListener("pointercancel", endDrag);
      thumbRail.addEventListener("wheel", (e) => {
        if (!window.matchMedia("(max-width: 960px)").matches || Math.abs(e.deltaX) >= Math.abs(e.deltaY)) return;
        const max = thumbRail.scrollWidth - thumbRail.clientWidth;
        const next = thumbRail.scrollLeft + e.deltaY;
        if ((next > 0 && thumbRail.scrollLeft < max) || (next < 0 && thumbRail.scrollLeft > 0)) {
          e.preventDefault();
          thumbRail.scrollLeft = Math.max(0, Math.min(max, next));
        }
      }, { passive: false });
    }
    switchGallery(0);
  }

  /* =======================================================
     VARIANTS: instant crossfade, zero layout shift
  ======================================================= */
  function selectedOptions() {
    return $$("[data-variant-picker] .variant-group").map((g) => {
      const active = $(".vopt[data-active]", g);
      return active ? active.getAttribute("value") : null;
    });
  }
  function findVariant(opts) {
    return VARIANTS.find((v) => v.options.length === opts.length && v.options.every((o, i) => o === opts[i]));
  }

  function updateVariant(variant, updateURL) {
    STATE.variant = variant;

    // hidden form input (source of truth for add-to-cart + checkout)
    const input = $("[data-variant-id-input]");
    if (input) input.value = variant ? variant.id : "";

    // price block
    const pe = $("#pdpPrice");
    const ce = $("#pdpCompare");
    const se = $("#pdpSave");
    if (variant) {
      if (pe) pe.textContent = variant.price_money;
      const price = Number(variant.price) || 0;
      const compareAt = Number(variant.compare_at_price) || 0;
      const onSale = compareAt > price;
      if (ce) { if (onSale) { ce.textContent = variant.compare_money; ce.hidden = false; } else { ce.textContent = ""; ce.hidden = true; } }
      if (se) { if (onSale) { se.textContent = "Save " + formatMoney(compareAt - price); se.hidden = false; } else { se.textContent = ""; se.hidden = true; } }
    }

    // ATC + sticky availability
    const available = variant && variant.available;
    const atc = $("#pdpAtc");
    const label = atc && $(".atc-label", atc);
    const tag = $("#pdpAtcPrice");
    if (atc) atc.disabled = !available;
    if (label) label.textContent = available ? (CFG.strings && CFG.strings.addToCart || "Add to cart") : (CFG.strings && CFG.strings.soldOut || "Sold out");
    if (tag && variant) tag.textContent = formatMoney(variant.price * STATE.qty);

    const sName = $("#stickyVar");
    const sPrice = $("#stickyPrice");
    const sAdd = $("#stickyAtc");
    if (sName && variant) sName.textContent = variant.title;
    if (sPrice && variant) sPrice.textContent = variant.price_money;
    if (sAdd) sAdd.disabled = !available;

    // per-option selected label
    $$("[data-variant-picker] .variant-group").forEach((g) => {
      const active = $(".vopt[data-active]", g);
      const lab = $("[data-option-selected]", g);
      if (active && lab) lab.textContent = active.getAttribute("value");
    });

    // gallery → variant media
    if (variant && variant.featured_media_id) {
      const idx = galleryIndexForMediaId(variant.featured_media_id);
      if (idx > -1) switchGallery(idx);
    }

    // URL (History API, no reload): only on user interaction
    if (updateURL && variant && window.history && window.history.replaceState) {
      const url = new URL(window.location.href);
      url.searchParams.set("variant", variant.id);
      window.history.replaceState({}, "", url.toString());
    }

    window.dispatchEvent(new CustomEvent("pc:variant", { detail: { variant } }));
  }

  function initVariants() {
    const picker = $("[data-variant-picker]");
    if (!picker) { return; }
    picker.addEventListener("click", (e) => {
      const opt = e.target.closest(".vopt");
      if (!opt) return;
      const group = opt.closest(".variant-group");
      $$(".vopt", group).forEach((o) => { o.removeAttribute("data-active"); o.setAttribute("aria-checked", "false"); });
      opt.setAttribute("data-active", ""); opt.setAttribute("aria-checked", "true");
      const variant = findVariant(selectedOptions());
      updateVariant(variant, true);
    });
  }

  /* =======================================================
     QUANTITY
  ======================================================= */
  function initQuantity() {
    const input = $("#pdpQty");
    if (!input) return;
    const clamp = (v) => Math.max(1, Math.min(99, v || 1));
    const set = (v) => {
      STATE.qty = clamp(v); input.value = STATE.qty;
      const tag = $("#pdpAtcPrice");
      if (tag && STATE.variant) tag.textContent = formatMoney(STATE.variant.price * STATE.qty);
    };
    $("#qtyDec") && $("#qtyDec").addEventListener("click", () => set(STATE.qty - 1));
    $("#qtyInc") && $("#qtyInc").addEventListener("click", () => set(STATE.qty + 1));
    input.addEventListener("change", () => set(parseInt(input.value, 10)));
    set(1);
  }

  /* =======================================================
     ADD TO CART (AJAX via app.js PCCart)
  ======================================================= */
  function addCurrent(fromEl) {
    if (!STATE.variant || !STATE.variant.available) return;
    const payload = { id: STATE.variant.id, quantity: STATE.qty };
    if (window.PCCart) window.PCCart.add(payload, fromEl);
    else { // hard fallback: native form post
      const form = $(".pdp-form"); if (form) form.submit();
    }
  }
  function initAtc() {
    const form = $(".pdp-form");
    if (form) {
      form.addEventListener("submit", (e) => {
        if (!window.PCCart) return; // allow native post
        e.preventDefault();
        addCurrent($("#pdpAtc"));
      });
    }
    const sticky = $("#stickyAtc");
    if (sticky) sticky.addEventListener("click", () => addCurrent(sticky));
  }

  /* =======================================================
     STICKY ATC BAR
  ======================================================= */
  function initStickyBar() {
    const bar = $("#stickyAtcBar");
    const anchor = $("#pdpAtc");
    if (!bar || !anchor) return;
    const onScroll = () => bar.toggleAttribute("data-show", anchor.getBoundingClientRect().bottom < 64);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
  }

  /* =======================================================
     ACCORDIONS (INCI + FAQ)
  ======================================================= */
  function initAccordions() {
    $$(".acc-item").forEach((item) => {
      const head = $(".acc-head", item);
      const panel = $(".acc-panel", item);
      if (!head || !panel) return;
      const inner = $(".acc-panel-inner", panel);
      head.setAttribute("aria-expanded", item.hasAttribute("data-open") ? "true" : "false");
      const setOpen = (open) => {
        item.toggleAttribute("data-open", open);
        head.setAttribute("aria-expanded", open ? "true" : "false");
        panel.style.height = open ? inner.offsetHeight + "px" : "0px";
      };
      if (item.hasAttribute("data-open") && inner) panel.style.height = inner.offsetHeight + "px";
      head.addEventListener("click", () => setOpen(!item.hasAttribute("data-open")));
      window.addEventListener("resize", () => { if (item.hasAttribute("data-open") && inner) panel.style.height = inner.offsetHeight + "px"; });
    });
  }

  /* =======================================================
     REVIEW BREAKDOWN BARS
  ======================================================= */
  function initReviewBars() {
    const wrap = $(".rev-bars");
    const bars = $$(".rev-bar .rb-fill");
    if (!wrap || !bars.length) return;
    const fill = () => bars.forEach((b) => b.style.width = (b.dataset.pct || 0) + "%");
    if (REDUCED) { fill(); return; }
    const io = new IntersectionObserver((entries) => {
      entries.forEach((en) => { if (en.isIntersecting) { fill(); io.disconnect(); } });
    }, { threshold: 0.3 });
    io.observe(wrap);
  }

  /* =======================================================
     ASYNC REVIEW WIDGETS
     Reserve space until Judge.me paints, initialise once, and keep the
     legacy write-review bridge safe when the app is late or unavailable.
  ======================================================= */
  function initReviewWidgets() {
    const widgets = $$(".jdgm-review-widget, [data-jdgm-zone]");
    if (!widgets.length) return;

    const widgetIsReady = (widget) => {
      if (widget.matches(".jdgm--done-setup-widget")) return true;
      if (widget.matches("[data-jdgm-zone]")) {
        const embedded = $(".jdgm-review-widget", widget);
        return !!embedded && widgetIsReady(embedded);
      }
      return widget.childElementCount > 0 && widget.getBoundingClientRect().height > 80;
    };

    const markReady = (widget) => {
      widget.classList.add("pc-review-ready");
      widget.classList.remove("pc-review-timeout");
      widget.removeAttribute("aria-busy");
    };

    widgets.forEach((widget) => {
      if (widget.dataset.pcReviewInit === "1") return;
      widget.dataset.pcReviewInit = "1";

      if (widgetIsReady(widget)) {
        markReady(widget);
      } else {
        widget.setAttribute("aria-busy", "true");
        let observer;
        const check = () => {
          if (!widget.isConnected || !widgetIsReady(widget)) return false;
          markReady(widget);
          if (observer) observer.disconnect();
          return true;
        };

        if ("MutationObserver" in window) {
          observer = new MutationObserver(check);
          observer.observe(widget, { childList: true, subtree: true, attributes: true, attributeFilter: ["class"] });
        }

        window.setTimeout(() => {
          if (check()) return;
          widget.classList.add("pc-review-timeout");
          widget.removeAttribute("aria-busy");
        }, 12000);
        window.setTimeout(() => { if (observer) observer.disconnect(); }, 30000);
      }

      const zone = widget.matches("[data-jdgm-zone]") ? widget : widget.closest("[data-jdgm-zone]");
      if (!zone) return;
      const button = $("[data-jdgm-write]", zone);
      const hint = $("[data-jdgm-hint]", zone);
      if (!button || button.dataset.pcReviewInit === "1") return;
      button.dataset.pcReviewInit = "1";
      button.addEventListener("click", (event) => {
        event.preventDefault();
        const nativeButton = $(".jdgm-write-rev-link", zone) || $(".jdgm-write-rev-link");
        if (nativeButton) {
          nativeButton.click();
          return;
        }
        if (hint) hint.hidden = false;
        widget.scrollIntoView({ behavior: REDUCED ? "auto" : "smooth", block: "start" });
        window.setTimeout(() => { if (hint) hint.hidden = true; }, 6000);
      });
    });
  }

  /* =======================================================
     SHARE + INSTANT BUY-BOX REVEAL + RECENTLY VIEWED
  ======================================================= */
  function initShare() {
    $$("[data-share]").forEach((btn) => btn.addEventListener("click", async () => {
      const data = { title: document.title, url: window.location.href };
      try { if (navigator.share) await navigator.share(data); else { await navigator.clipboard.writeText(data.url); btn.classList.add("copied"); setTimeout(() => btn.classList.remove("copied"), 1500); } } catch (e) {}
    }));
  }
  function initInstantBuyBox() {
    $$("#pdpBuy .mask-headline").forEach((el) => el.classList.add("is-in"));
  }
  const RECENT_KEY = "pc_recent_v2";
  function recordRecentlyViewed() {
    try {
      const el = $("[data-product-summary]");
      if (!el) return;
      const data = JSON.parse(el.textContent);
      if (!data.handle) return;
      let list = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]");
      list = list.filter((p) => p.handle !== data.handle);
      list.unshift(data);
      localStorage.setItem(RECENT_KEY, JSON.stringify(list.slice(0, 12)));
    } catch (e) {}
  }
  function recentCard(p) {
    const img = p.image ? `<img src="${p.image}&width=440" loading="lazy" width="320" height="426" class="pcard-img pcard-img--main" alt="${(p.title || "").replace(/"/g, "&quot;")}">` : `<div class="ph"><span class="ph-label">${p.vendor || ""}</span></div>`;
    return `<article class="pcard" data-glow-zone>
      <div class="pcard-media pcard-media--${(window.PC_CONFIG && PC_CONFIG.cardRatio) || "portrait"}">
        <a href="${p.url}" class="pcard-media-link" data-prefetch aria-label="${(p.title || "").replace(/"/g, "&quot;")}">${img}</a>
      </div>
      <div class="pcard-body">
        ${p.vendor ? `<div class="pcard-brand">${p.vendor}</div>` : ""}
        <div class="pcard-name"><a href="${p.url}" data-prefetch>${p.title || ""}</a></div>
        <div class="pcard-foot"><span class="pcard-price">${p.price || ""}</span></div>
      </div>
    </article>`;
  }
  function renderRecentlyViewed() {
    const wrap = $("[data-recently-viewed]");
    const track = $("#recentTrack");
    if (!wrap || !track) return;
    let list = [];
    try { list = JSON.parse(localStorage.getItem(RECENT_KEY) || "[]"); } catch (e) {}
    const current = $("[data-product-summary]");
    let currentHandle = "";
    try { currentHandle = current ? JSON.parse(current.textContent).handle : ""; } catch (e) {}
    list = list.filter((p) => p.handle !== currentHandle);
    if (!list.length) { wrap.hidden = true; return; }
    track.innerHTML = list.map(recentCard).join("");
    wrap.hidden = false;
    if (window.PCInitCarousels) window.PCInitCarousels();
  }

  function initRecommendations() {
    $$("[data-product-recommendations]").forEach((el) => {
      const url = el.dataset.url;
      if (!url || el.dataset.loaded) return;
      // already server-rendered with products? leave it.
      if ($(".pcard:not(.pcard--skeleton)", el)) { el.dataset.loaded = "1"; return; }
      fetch(url)
        .then((r) => r.text())
        .then((text) => {
          const doc = new DOMParser().parseFromString(text, "text/html");
          const fresh = doc.querySelector("[data-product-recommendations]");
          if (fresh && fresh.innerHTML.trim()) { el.innerHTML = fresh.innerHTML; }
          el.dataset.loaded = "1";
          if (window.PCInitCarousels) window.PCInitCarousels();
        })
        .catch(() => { el.dataset.loaded = "1"; });
    });
  }

  /* =======================================================
     CHECKBOX BUNDLE: running total seeded by the page product
     (tick a carousel product → its price is added; untick → removed)
  ======================================================= */
  function initBundles() {
    $$("[data-bundle-scope]").forEach((scope) => {
      const totalEl = $("[data-bundle-total]", scope);
      const addBtn = $("[data-bundle-add]", scope);
      const boxes = $$("[data-bundle-item]", scope);
      let basePrice = parseInt(scope.dataset.basePrice, 10) || 0;
      let baseVariant = scope.dataset.baseVariant || "";

      function recompute() {
        let total = basePrice;
        boxes.forEach((b) => { if (b.checked && !b.disabled) total += parseInt(b.dataset.price, 10) || 0; });
        if (totalEl) totalEl.textContent = formatMoney(total);
      }

      scope.addEventListener("change", (e) => {
        const box = e.target.closest("[data-bundle-item]");
        if (!box) return;
        const cell = box.closest("[data-bundle-cell]");
        if (cell) cell.classList.toggle("is-selected", box.checked);
        recompute();
      });

      // Keep the base in sync with the page product's selected variant.
      window.addEventListener("pc:variant", (e) => {
        const v = e.detail && e.detail.variant;
        if (!v) return;
        basePrice = v.price;
        baseVariant = String(v.id);
        recompute();
      });

      if (addBtn) addBtn.addEventListener("click", () => {
        const items = [];
        if (baseVariant) items.push({ id: baseVariant, quantity: 1 });
        boxes.forEach((b) => { if (b.checked && !b.disabled) items.push({ id: b.dataset.variantId, quantity: 1 }); });
        if (items.length && window.PCCart) window.PCCart.add(items, addBtn);
      });

      recompute();
    });
  }

  /* =======================================================
     GALLERY LIGHTBOX: full-screen image viewer with prev/next,
     keyboard & swipe navigation; opens on gallery image click.
  ======================================================= */
  function initLightbox() {
    const dialog = document.getElementById("galleryLightbox");
    const stage = document.getElementById("glbStage");
    const viewport = document.getElementById("galleryMain");
    if (!dialog || !stage || !viewport) return;

    let lbIdx = 0;

    function getSlides() { return $$(".gslide", viewport); }

    function loadSlide(idx) {
      const slides = getSlides();
      if (!slides.length) return;
      lbIdx = Math.max(0, Math.min(slides.length - 1, idx));
      const img = slides[lbIdx].querySelector("img.gmain-img");
      stage.innerHTML = "";
      if (!img) return;
      const el = new Image();
      const raw = img.getAttribute("src") || "";
      el.src = raw.includes("&width=") ? raw.replace(/&width=\d+/, "&width=2400") : raw;
      el.alt = img.alt || "";
      stage.appendChild(el);
      // show/hide arrows based on count
      const prev = document.getElementById("glbPrev");
      const next = document.getElementById("glbNext");
      if (prev) prev.hidden = slides.length <= 1;
      if (next) next.hidden = slides.length <= 1;
    }

    function openLb(idx) {
      loadSlide(idx);
      dialog.showModal();
      document.body.style.overflow = "hidden";
    }

    function closeLb() { dialog.close(); }

    function stepLb(dir) {
      const count = getSlides().length;
      if (count <= 1) return;
      loadSlide(((lbIdx + dir) + count) % count);
    }

    // Make gallery images open lightbox on click
    getSlides().forEach((slide, i) => {
      const img = slide.querySelector("img.gmain-img");
      if (img) img.addEventListener("click", () => openLb(i));
    });

    // All cleanup runs on the native close event (covers Escape key too)
    dialog.addEventListener("close", () => {
      stage.innerHTML = "";
      document.body.style.overflow = "";
      switchGallery(lbIdx);
    });

    // Close when clicking outside the image/arrows/close button
    dialog.addEventListener("click", (e) => {
      if (!e.target.closest("img") && !e.target.closest(".glb-arrow") && !e.target.closest(".glb-close")) closeLb();
    });

    document.getElementById("glbClose") && document.getElementById("glbClose").addEventListener("click", closeLb);
    document.getElementById("glbPrev") && document.getElementById("glbPrev").addEventListener("click", () => stepLb(-1));
    document.getElementById("glbNext") && document.getElementById("glbNext").addEventListener("click", () => stepLb(1));

    dialog.addEventListener("keydown", (e) => {
      if (e.key === "ArrowLeft") { e.preventDefault(); stepLb(-1); }
      if (e.key === "ArrowRight") { e.preventDefault(); stepLb(1); }
    });

    // Swipe to navigate on touch
    let lbTouchX = 0;
    stage.addEventListener("touchstart", (e) => { lbTouchX = e.touches[0].clientX; }, { passive: true });
    stage.addEventListener("touchend", (e) => {
      const dx = e.changedTouches[0].clientX - lbTouchX;
      if (Math.abs(dx) > 50) stepLb(dx < 0 ? 1 : -1);
    });
  }

  /* ---------------- BOOT ---------------- */
  let booted = false;
  function boot() {
    if (booted) return;
    booted = true;
    initInstantBuyBox();
    initGallery();
    initLightbox();
    initVariants();
    initQuantity();
    initAtc();
    initStickyBar();
    initAccordions();
    initReviewBars();
    initReviewWidgets();
    initShare();
    recordRecentlyViewed();
    renderRecentlyViewed();
    initRecommendations();
    initBundles();
    const initialVariant = findVariant(selectedOptions()) || STATE.variant;
    if (initialVariant) updateVariant(initialVariant, false);
  }

  if (window.__pcReady) boot();
  else window.addEventListener("pc:ready", boot, { once: true });
  setTimeout(boot, 4200);
})();
